exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-component{height:90px;font-size:.75em}.indent{padding:42px 40px 20px}.banner-links{display:inline;margin-right:5px;padding:3px}.fleft{float:left}#footer{height:280px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/Footer.css
// module id = 141
// module chunks = 0